import {
  getWixConfigFilePath,
  WIX_CONFIG_FILENAME,
} from '@wix/cli-core-definitions';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { pathExists, readJson } from '@wix/cli-fs';
import { z } from 'zod';

const wixConfigSchema = z.object({}).passthrough();

export type WixConfigSchema = z.infer<typeof wixConfigSchema>;

export async function readWixConfig(projectFolder: string) {
  const configFile = await readJson(getWixConfigFilePath(projectFolder));
  const config = wixConfigSchema.safeParse(configFile);

  if (config.success) {
    return config.data;
  }

  throw new CliError({
    cause: config.error,
    code: CliErrorCode.InvalidConfigSchemaError({
      configPath: WIX_CONFIG_FILENAME,
      zodError: config.error,
    }),
  });
}

export function isWixConfigExists(projectFolder: string) {
  return pathExists(getWixConfigFilePath(projectFolder));
}
